import { getDocs, collection, query, where } from "@firebase/firestore";
import { hideLoading, setForRentWigsList, showLoading } from "./for-rent-wigs-list-slice";
import { showErrorSnackbar } from "../../../../shared/snackbar/snackbar-slice";

export const getForRentWigsService = async (dispatch, db, coll) => {
    try {
        dispatch(showLoading());
        const querySnapshot = await getDocs(
            query(collection(db, coll), where("type", "==", "For rent"), where("category", "==", "Wig"))
        );
        const data = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
        }));
        dispatch(setForRentWigsList(data));
        dispatch(hideLoading());
    } catch (e) {
        dispatch(showErrorSnackbar('Fetch failed! Please try again.'))
        console.error("ForRentWigsList getForRentWigsService error: ", e);
    }
};